import { useQuery, useLazyQuery, gql } from "@apollo/client"
import { toId } from "@utils/data"
import { SENSOR_DEVICE_FIELDS } from "./fragments/sensorFieldsFragment"

const SENSORS_QUERY = gql`
  query Sensors($location: ID!) {
    sensors(location: $location) {
      list {
        ...SensorDeviceFields
      }
    }
  }
  ${SENSOR_DEVICE_FIELDS}
`

const sensorsTypePolicies = {
  root: {
    sensors: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      }
    }
  },
  scoped: {
    SensorsQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      }
    }
  }
}

const useQuerySensors = (options) => useQuery(SENSORS_QUERY, options)

const useLazyQuerySensors = (options) => useLazyQuery(SENSORS_QUERY, options)

// Gets a single sensor from the latest readings cache
const useQuerySensorLatest = (id, location) => {
  const { data } = useQuery(SENSORS_QUERY, {
    variables: { location: toId(location, true) },
    skip: !location || !id,
    fetchPolicy: "cache-and-network"
  })

  const sensor = data?.sensors?.list.find((item) => item.id === id)

  return { sensor }
}

export { useQuerySensors, useLazyQuerySensors, useQuerySensorLatest, sensorsTypePolicies }
